import { render, staticRenderFns } from "./ModalSendSMS.vue?vue&type=template&id=52aa89e0&"
import script from "./ModalSendSMS.vue?vue&type=script&lang=js&"
export * from "./ModalSendSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports